import { z } from 'zod'

import { PersonaInfoSummary } from '@/modules/shared/schemas/PersonaInfoSummary'

import { AvailabilityTypes } from './AvailabilityTypes'

export const CAA = z.object({
  id: z.string(),
  therapist: PersonaInfoSummary,
  patient: PersonaInfoSummary,
  specialty: z.object({
    id: z.string(),
    name: z.string()
  }),
  start: z.string(),
  end: z.string().nullable(),
  register: z.string().nullable(),
  availability: AvailabilityTypes,
  customerUse: z.number(),
  modeling: z.number()
})

export type CAA = z.infer<typeof CAA>
